module.exports = __webpack_public_path__ + "static/media/action_edit.95af0ead.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/action_edit.svg
// module id = 127
// module chunks = 0